// extracted by mini-css-extract-plugin
export default {"table":"Table_table__aqb4e","btt":"Table_btt__bohw8"};